import { ScreenSize } from '@libs/shared-services';
import {
  Coordinates,
  GUM_INTERMEDIATE_BUMP,
  Jaw,
  PERIO_SPACE_BETWEEN_FACIAL_AND_LINGUAL,
  SPACE_BETWEEN_MANIBULAR_AND_MAXILLARY,
  TOOTH_HEIGHT,
  TOOTH_PERIO_HEIGHT,
  ToothSide,
} from '@libs/ui-lib';

export const PERIO_TOP_PADDING = 45;
export const PERIO_MISSING_TEETH_SPACE_BETWEEN_FACIAL_AND_LINGUAL = 10;

export const TEETH_TRANSLATE_Y = (
  screenSize: ScreenSize,
  spaceBetweenFacialAndLingual = PERIO_SPACE_BETWEEN_FACIAL_AND_LINGUAL,
  spaceBetweenMaxillaryAndMandibular = SPACE_BETWEEN_MANIBULAR_AND_MAXILLARY,
): { upper: { buccal: number; lingual: number }; lower: { buccal: number; lingual: number } } => {
  return {
    upper: {
      buccal: PERIO_TOP_PADDING,
      lingual: PERIO_TOP_PADDING + TOOTH_PERIO_HEIGHT(screenSize) + spaceBetweenFacialAndLingual,
    },
    lower: {
      lingual:
        PERIO_TOP_PADDING +
        TOOTH_PERIO_HEIGHT(screenSize) +
        spaceBetweenFacialAndLingual +
        TOOTH_PERIO_HEIGHT(screenSize) +
        spaceBetweenMaxillaryAndMandibular,
      buccal:
        PERIO_TOP_PADDING +
        TOOTH_PERIO_HEIGHT(screenSize) +
        spaceBetweenFacialAndLingual +
        TOOTH_PERIO_HEIGHT(screenSize) +
        spaceBetweenMaxillaryAndMandibular +
        TOOTH_PERIO_HEIGHT(screenSize) +
        spaceBetweenFacialAndLingual,
    },
  };
};

export const PERIO_TRANSLATE_Y =
  (screenSize: ScreenSize) =>
  (jaw: Jaw, side: ToothSide, coordinates: Coordinates, measurementsCoordinates: Coordinates, pocketDepth: number): number => {
    const MEASUREMENT_INCREMENTS = 3.5;
    const y = {
      upper: {
        buccal: coordinates.y + measurementsCoordinates.y - pocketDepth * MEASUREMENT_INCREMENTS,
        lingual: coordinates.y - measurementsCoordinates.y + pocketDepth * MEASUREMENT_INCREMENTS + TOOTH_HEIGHT(screenSize),
      },
      lower: {
        lingual: coordinates.y - measurementsCoordinates.y - pocketDepth * MEASUREMENT_INCREMENTS + TOOTH_HEIGHT(screenSize),
        buccal: coordinates.y + measurementsCoordinates.y + pocketDepth * MEASUREMENT_INCREMENTS,
      },
    };
    return y[jaw][side];
  };

export const GUM_INTERMEDIARY_BUMP =
  (screenSize: ScreenSize) =>
  (jaw: Jaw, side: ToothSide): number => {
    return GUM_INTERMEDIATE_BUMP(screenSize) * ((jaw === 'upper' && side === 'buccal') || (jaw === 'lower' && side === 'lingual') ? 1 : -1);
  };
